<template>
  <div class="price-modular">
    <div class="price-banner center">
      <div class="banner-title font-light">
        全面满足各行业<br
          v-if="$store.state.sceneClassName === 'app'"
        />多场景应用
      </div>
      <div class="banner-sub-title">免费试用7天后，可按需选择合适版本</div>
      <a
        v-if="$store.state.sceneClassName === 'app'"
        href="/"
        target="_blank"
        class="free-price-btn"
        >立即创建体验</a
      >
      <a v-else href="/" target="_blank" class="BigBtnType1">免费试用</a>
    </div>
    <div class="type-wrap">
      <div v-if="$store.state.sceneClassName === 'app'">
        <swiper :options="swiperOptions">
          <swiper-slide v-for="item in 3" :key="`cmb_${item}`">
            <div class="version-top">
              <p class="version-title">标准版</p>
            </div>
            <div class="version-desc-area">
              <p class="version-desc-person">
                适合初创型团队或个人运营<br />解决社群化学习的基础需求
              </p>
              <div class="version-content">
                <p class="version-desc-content">
                  <span class="version-desc-point"></span
                  >支持多种内容形式与变现方式
                </p>
                <p class="version-desc-content">
                  <span class="version-desc-point"></span
                  >覆盖直播营销、品牌传播等场景
                </p>
                <p class="version-desc-content">
                  <span class="version-desc-point"></span>快速实现线上轻量化转型
                </p>
              </div>
              <div class="version-price">
                <h3 class="price">￥4800<span>/年</span></h3>
              </div>
              <a href="/" class="version-buy-btn">立即购买</a>
            </div>
          </swiper-slide>
        </swiper>
      </div>
      <div v-else class="w1200 mainContent">
        <div class="type">
          <div class="type-item type-item__normal">
            <div class="type-header type-header-one">标准版</div>
            <div class="version-person">
              适合初创型团队或个人运营<br />解决社群化学习的基础需求
            </div>
            <div class="version-desc">
              <p class="version-content">
                <span class="version-point"></span>支持多种内容形式与变现方式
              </p>
              <p class="version-content">
                <span class="version-point"></span>覆盖直播营销、品牌传播等场景
              </p>
              <p class="version-content">
                <span class="version-point"></span>快速实现线上轻量化转型
              </p>
            </div>
            <div class="price-box">
              <div class="type-price">
                <span class="priceIcon c-3DA4FF">￥</span>
                <span class="type-price-num c-3DA4FF">4800</span>
                <span class="c-3DA4FF">/年</span>
              </div>
            </div>
            <a
              href="https://admin.getchain.cn/login_page?reg_source=1103#/register"
              data-count="pc-服务价格_4800选购"
              class="type-btn type-btn-one"
              >立即购买</a
            >
          </div>
          <div class="type-item type-item__edu">
            <div class="type-header type-header-two">
              专业版
              <span class="type-header-desc">包含标准版全部功能</span>
              <div class="tip_module">
                <div class="tip">
                  <img
                    src="http://wechatapppro-1252524126.file.myqcloud.com/apppcHqlTPT3482/image/kiolyp3r0do14r0q4gz7.png"
                    class="tip-icon"
                    alt=""
                  />
                  <div class="tip-text">
                    <img
                      src="http://wechatapppro-1252524126.file.myqcloud.com/apppcHqlTPT3482/image/kiolyp3s0kbq2q22ue7i.png"
                      data-no-retina=""
                      alt=""
                    />
                  </div>
                </div>
              </div>
            </div>
            <img
              src="http://wechatapppro-1252524126.file.myqcloud.com/appAKLWLitn7978/image/ed0ae801161a849f555ad5256df224a4.png"
              alt=""
              class="recommend_img"
            />
            <div class="version-person">
              适合成长型团队经营<br />覆盖线上线下结合的经营场景
            </div>
            <div class="version-desc">
              <p class="version-content">
                <span class="version-point"></span
                >丰富的知识产品形式与营销、助学工具
              </p>
              <p class="version-content">
                <span class="version-point"></span
                >具备教务排课管理与实物电商能力
              </p>
              <p class="version-content">
                <span class="version-point"></span>满足线下门店经营需求
              </p>
              <p class="version-content">
                <span class="version-point"></span
                >支持信息采集与触达管理，构建用户运营闭环
              </p>
            </div>
            <div class="price-box">
              <div class="type-price">
                <span class="priceIcon c-2D74F1">￥</span>
                <span class="type-price-num c-2D74F1">7999</span>
                <span class="c-2D74F1">/年</span>
              </div>
            </div>
            <a
              href="https://admin.getchain.cn/login_page?reg_source=1103#/register"
              data-count="pc-服务价格_7999选购"
              class="type-btn type-btn-two"
              >立即购买</a
            >
          </div>
          <div class="type-item type-item__more">
            <div class="type-header type-header-three">
              旗舰版
              <span class="type-header-desc"
                >包含标准版&amp;专业版全部功能</span
              >
            </div>
            <div class="version-person">
              适合成熟机构体系化经营<br />满足多个深度场景需求
            </div>
            <div class="version-desc">
              <p class="version-content">
                <span class="version-point"></span
                >全面满足品牌营销、商业变现、用户运营等需求
              </p>
              <p class="version-content">
                <span class="version-point"></span
                >拥有内训产品功能及组织管理功能
              </p>
              <p class="version-content">
                <span class="version-point"></span
                >更佳的用户管理体验，实现用户沉淀与复购增购
              </p>
              <p class="version-content">
                <span class="version-point"></span
                >配套大容量空间及数千个管理员账号
              </p>
              <p class="version-content">
                <span class="version-point"></span
                >满足多个团队异地管理、共同经营等规模化扩张需求
              </p>
            </div>
            <div class="price-box">
              <div class="type-price">
                <span class="priceIcon c-B98666">￥</span>
                <span class="type-price-num c-B98666">19999</span>
                <span class="c-B98666">/年</span>
              </div>
            </div>
            <a
              href="https://admin.getchain.cn/login_page?reg_source=1103#/register"
              data-count="pc-服务价格_19999选购"
              class="type-btn type-btn-three"
              >立即购买</a
            >
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="$store.state.sceneClassName === 'app'"
      class="server-list-wrapper"
    >
      <div :class="`server-list-title ${serverListFixedClass}`">
        <div class="assist">
          <div class="compare">
            <div class="left function">功能介绍</div>
            <div class="list-swiper">
              <div class="swiper-wrapper">
                <div class="swiper-slide">标准版</div>
                <div class="swiper-slide">专业版</div>
                <div class="swiper-slide">旗舰版</div>
              </div>
            </div>
          </div>
          <div class="category">
            <div class="caption">{{ sidebarActiveApp.title }}</div>
            <div class="direction">
              <span class="inclued">已包含</span>
              <span class="canBuy">可购买</span>
              <span class="noBuy">不可购买</span>
            </div>
          </div>
        </div>
      </div>
      <div class="server-list-detail">
        <div class="left">
          <div
            class="group"
            v-for="(item, index) in sidebarArr"
            :key="item.id + index"
            :id="item.id"
          >
            <div class="category">
              <div class="caption">{{ item.title }}</div>
              <div class="direction">
                <span class="inclued">已包含</span>
                <span class="canBuy">可购买</span>
                <span class="noBuy">不可购买</span>
              </div>
            </div>
            <div
              class="item"
              v-for="(sItem, sIndex) in item.produce"
              :key="item.id + index + sIndex"
            >
              {{ sItem.title }}
            </div>
          </div>
        </div>
        <div class="list-desc-content">
          <div class="swiper-wrapper">
            <div class="swiper-slide" v-for="item in 3" :key="item + 'ldc'">
              <div class="list-group type-single">
                <div class="list-item">
                  <p class="inner">
                    <span class="style-circle"></span>
                  </p>
                </div>
                <div class="list-item">
                  <p class="inner">
                    <span class="style-circle"></span>
                  </p>
                </div>
                <div class="list-item">
                  <p class="inner">
                    <span class="style-circle"></span>
                  </p>
                </div>
                <div class="list-item">
                  <p class="inner">
                    <span class="style-circle"></span>
                  </p>
                </div>
                <div class="list-item">
                  <p class="inner">
                    <span class="style-circle"></span>
                  </p>
                </div>
                <div class="list-item">
                  <p class="inner">
                    <span class="style-circle"></span>
                  </p>
                </div>
                <div class="list-item">
                  <p class="inner">
                    <span class="style-radius"></span>
                    <span class="inner-price">&yen;988/年</span>
                  </p>
                </div>
                <div class="list-item">
                  <p class="inner">
                    <span class="style-radius"></span>
                    <span class="inner-price">&yen;988/年</span>
                  </p>
                </div>
                <div class="list-item">
                  <p class="inner">
                    <span class="style-radius"></span>
                    <span class="inner-price">&yen;1988/年</span>
                  </p>
                </div>
              </div>

              <div class="list-group type-group" style="height: 2.88rem">
                <div class="list-item group-item">
                  <p class="inner">
                    <span class="style-radius"></span>
                    <span class="inner-price">&yen;1988/年</span>
                  </p>
                </div>
              </div>

              <div class="list-group type-group" style="height: 9.6rem">
                <div class="list-item group-item">
                  <p class="inner inner-column">
                    <span class="style-circle"></span>

                    <span class="inner-text">不限人次，免流量费，零延迟</span>
                  </p>
                </div>
              </div>
              <div class="type-single">
                <div class="list-item">
                  <p class="inner">
                    <span class="inner-desc">720P</span>
                  </p>
                </div>
              </div>

              <div class="list-group type-group" style="height: 5.76rem">
                <div class="list-item group-item">
                  <p class="inner inner-column">
                    <span class="style-circle"></span>

                    <span class="inner-text">新客户赠送100元流量费用</span>
                  </p>
                </div>
              </div>
              <div class="list-group type-single">
                <div class="list-item">
                  <p class="inner">
                    <span class="style-line"></span>
                  </p>
                </div>
                <div class="list-item">
                  <p class="inner">
                    <span class="style-line"></span>
                  </p>
                </div>
                <div class="list-item">
                  <p class="inner">
                    <span class="style-line"></span>
                  </p>
                </div>
                <div class="list-item">
                  <p class="inner">
                    <span class="style-line"></span>
                  </p>
                </div>
                <div class="list-item">
                  <p class="inner">
                    <span class="style-line"></span>
                  </p>
                </div>
              </div>

              <div class="list-group type-single">
                <div class="list-item">
                  <p class="inner">
                    <span class="style-line"></span>
                  </p>
                </div>
                <div class="list-item">
                  <p class="inner">
                    <span class="style-line"></span>
                  </p>
                </div>
              </div>

              <div class="list-group type-single">
                <div class="list-item">
                  <p class="inner">
                    <span class="style-circle"></span>
                  </p>
                </div>
                <div class="list-item">
                  <p class="inner">
                    <span class="style-circle"></span>
                  </p>
                </div>
                <div class="list-item">
                  <p class="inner">
                    <span class="style-radius"></span>
                    <span class="inner-price">&yen;388/年</span>
                  </p>
                </div>
                <div class="list-item">
                  <p class="inner">
                    <span class="style-radius"></span>
                    <span class="inner-price">&yen;388/年</span>
                  </p>
                </div>
                <div class="list-item">
                  <p class="inner">
                    <span class="style-radius"></span>
                    <span class="inner-price">&yen;388/年</span>
                  </p>
                </div>
                <div class="list-item">
                  <p class="inner">
                    <span class="style-radius"></span>
                    <span class="inner-price">&yen;388/年</span>
                  </p>
                </div>
                <div class="list-item">
                  <p class="inner">
                    <span class="style-radius"></span>
                    <span class="inner-price">&yen;388/年</span>
                  </p>
                </div>
                <div class="list-item">
                  <p class="inner">
                    <span class="style-radius"></span>
                    <span class="inner-price">&yen;388/年</span>
                  </p>
                </div>
              </div>

              <div class="list-group type-single">
                <div class="list-item">
                  <p class="inner">
                    <span class="style-circle"></span>
                  </p>
                </div>
                <div class="list-item">
                  <p class="inner">
                    <span class="style-circle"></span>
                  </p>
                </div>
                <div class="list-item">
                  <p class="inner">
                    <span class="style-circle"></span>
                  </p>
                </div>
                <div class="list-item">
                  <p class="inner">
                    <span class="style-circle"></span>
                  </p>
                </div>
                <div class="list-item">
                  <p class="inner">
                    <span class="style-circle"></span>
                  </p>
                </div>
                <div class="list-item">
                  <p class="inner">
                    <span class="style-circle"></span>
                  </p>
                </div>
                <div class="list-item">
                  <p class="inner">
                    <span class="style-circle"></span>
                  </p>
                </div>
                <div class="list-item">
                  <p class="inner">
                    <span class="style-circle"></span>
                  </p>
                </div>
                <div class="list-item">
                  <p class="inner">
                    <span class="style-circle"></span>
                  </p>
                </div>
                <div class="list-item">
                  <p class="inner">
                    <span class="style-circle"></span>
                  </p>
                </div>
                <div class="list-item">
                  <p class="inner">
                    <span class="style-circle"></span>
                  </p>
                </div>
                <div class="list-item">
                  <p class="inner">
                    <span class="style-radius"></span>
                    <span class="inner-price">&yen;388/年</span>
                  </p>
                </div>
                <div class="list-item">
                  <p class="inner">
                    <span class="style-radius"></span>
                    <span class="inner-price">&yen;388/年</span>
                  </p>
                </div>
                <div class="list-item">
                  <p class="inner">
                    <span class="style-radius"></span>
                    <span class="inner-price">&yen;588/年</span>
                  </p>
                </div>
                <div class="list-item">
                  <p class="inner">
                    <span class="style-radius"></span>
                    <span class="inner-price">&yen;388/年</span>
                  </p>
                </div>
                <div class="list-item">
                  <p class="inner">
                    <span class="style-radius"></span>
                    <span class="inner-price">&yen;388/年</span>
                  </p>
                </div>
                <div class="list-item">
                  <p class="inner">
                    <span class="style-radius"></span>
                    <span class="inner-price">&yen;388/年</span>
                  </p>
                </div>
                <div class="list-item">
                  <p class="inner">
                    <span class="style-radius"></span>
                    <span class="inner-price">&yen;588/年</span>
                  </p>
                </div>
              </div>

              <div class="list-group type-single">
                <div class="list-item">
                  <p class="inner">
                    <span class="style-radius"></span>
                    <span class="inner-price">&yen;388/年</span>
                  </p>
                </div>
                <div class="list-item">
                  <p class="inner">
                    <span class="style-radius"></span>
                    <span class="inner-price">&yen;588/年</span>
                  </p>
                </div>
                <div class="list-item">
                  <p class="inner">
                    <span class="style-circle"></span>
                  </p>
                </div>
                <div class="list-item">
                  <p class="inner">
                    <span class="style-radius"></span>
                    <span class="inner-price">&yen;988/年</span>
                  </p>
                </div>
                <div class="list-item">
                  <p class="inner">
                    <span class="style-radius"></span>
                    <span class="inner-price">&yen;988/年</span>
                  </p>
                </div>
                <div class="list-item">
                  <p class="inner">
                    <span class="style-radius"></span>
                    <span class="inner-price">&yen;1988/年</span>
                  </p>
                </div>
              </div>

              <div class="list-group type-single">
                <div class="list-item">
                  <p class="inner">
                    <span class="style-circle"></span>
                  </p>
                </div>
                <div class="list-item">
                  <p class="inner">
                    <span class="style-circle"></span>
                  </p>
                </div>
                <div class="list-item">
                  <p class="inner">
                    <span class="style-circle"></span>
                  </p>
                </div>
                <div class="list-item">
                  <p class="inner">
                    <span class="style-circle"></span>
                  </p>
                </div>
                <div class="list-item">
                  <p class="inner">
                    <span class="style-line"></span>
                  </p>
                </div>
                <div class="list-item">
                  <p class="inner">
                    <span class="style-line"></span>
                  </p>
                </div>
              </div>

              <div class="list-group type-single">
                <div class="list-item">
                  <p class="inner">
                    <span class="style-circle"></span>
                  </p>
                </div>
              </div>

              <div class="list-group type-single">
                <div class="list-item">
                  <p class="inner">
                    <span class="inner-desc">高清720P</span>
                  </p>
                </div>
                <div class="list-item">
                  <p class="inner">
                    <span class="style-circle"></span>
                  </p>
                </div>
                <div class="list-item">
                  <p class="inner">
                    <span class="style-circle"></span>
                  </p>
                </div>
                <div class="list-item">
                  <p class="inner">
                    <span class="style-radius"></span>
                    <span class="inner-price">按需购买</span>
                  </p>
                </div>
              </div>

              <div class="list-group type-single">
                <div class="list-item">
                  <p class="inner">
                    <span class="style-circle"></span>
                  </p>
                </div>
                <div class="list-item">
                  <p class="inner">
                    <span class="style-radius"></span>
                    <span class="inner-price">&yen;1888/年</span>
                  </p>
                </div>
                <div class="list-item">
                  <p class="inner">
                    <span class="style-radius"></span>
                    <span class="inner-price">&yen;3988/年</span>
                  </p>
                </div>
                <div class="list-item">
                  <p class="inner">
                    <span class="style-radius"></span>
                    <span class="inner-price">&yen;49800/年</span>
                  </p>
                </div>
              </div>

              <div class="list-group type-single">
                <div class="list-item">
                  <p class="inner">
                    <span class="style-circle"></span>
                  </p>
                </div>
                <div class="list-item">
                  <p class="inner">
                    <span class="style-circle"></span>
                  </p>
                </div>
                <div class="list-item">
                  <p class="inner">
                    <span class="style-circle"></span>
                  </p>
                </div>
                <div class="list-item">
                  <p class="inner">
                    <span class="style-circle"></span>
                  </p>
                </div>
                <div class="list-item">
                  <p class="inner">
                    <span class="style-circle"></span>
                  </p>
                </div>
                <div class="list-item">
                  <p class="inner">
                    <span class="style-circle"></span>
                  </p>
                </div>
                <div class="list-item">
                  <p class="inner">
                    <span class="style-radius"></span>
                    <span class="inner-price">&yen;3988/年</span>
                  </p>
                </div>
                <div class="list-item">
                  <p class="inner">
                    <span class="inner-desc">200GB存储空间</span>
                  </p>
                </div>
                <div class="list-item">
                  <p class="inner">
                    <span class="style-circle"></span>
                  </p>
                </div>
                <div class="list-item">
                  <p class="inner">
                    <span class="inner-desc">3个</span>
                  </p>
                </div>
              </div>
              <div class="list-group type-single">
                <div class="list-item">
                  <p class="inner">
                    <span class="style-radius"></span>
                    <span class="inner-price">待定价</span>
                  </p>
                </div>
                <div class="list-item">
                  <p class="inner">
                    <span class="style-radius"></span>
                    <span class="inner-price">待定价</span>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else class="service-list toggle-up w1200">
      <div
        :class="`guide ${isShowSidebar ? 'guide-fixed__active' : ''}`"
        id="guideFixed"
      >
        <div class="guide-fixed w1200">
          <div class="guide-fixed__item list-wrap">
            <div>
              <div class="fun-list-intro">
                <i class="circle solidCircle"></i>
                <span class="T7">包含</span>
              </div>
              <div class="fun-list-intro">
                <i class="circle emptyCircle"></i>
                <span class="T7">不包含（支持独立购买）</span>
              </div>
              <div class="fun-list-intro">
                <i class="solidLine"></i>
                <span class="T7">不包含（不支持独立购买）</span>
              </div>
            </div>
          </div>
          <div class="guide-fixed__item">
            <h2 class="version-title">标准版</h2>
            <a
              href="https://admin.getchain.cn/login_page?reg_source=1103#/register"
              data-sensors="定价页_定价_标准版"
              data-count="pc-服务价格_标准版"
              class="type-btn type-btn-one"
              >立即购买</a
            >
          </div>
          <div class="guide-fixed__item">
            <h2 class="version-title">专业版</h2>
            <a
              href="https://admin.getchain.cn/login_page?reg_source=1103#/register"
              data-sensors="定价页_定价_专业版"
              data-count="pc-服务价格_专业版"
              class="type-btn type-btn-two"
              >立即购买</a
            >
          </div>
          <div class="guide-fixed__item">
            <h2 class="version-title">旗舰版</h2>
            <a
              href="https://admin.getchain.cn/login_page?reg_source=1103#/register"
              data-sensors="定价页_定价_旗舰版"
              data-count="pc-服务价格_旗舰版"
              class="type-btn type-btn-three"
              >立即购买</a
            >
          </div>
        </div>
      </div>
      <div
        :class="`service-side-bar-list ${isShowSidebar ? '' : 'hide'}`"
        id="service-side-bar-list"
        :style="{ left: '', top: sidebarTop + 'px' }"
      >
        <ul>
          <!-- active-current-side-bar -->
          <li
            v-for="(item, index) in sidebarArr"
            :key="`ssbl_${index}`"
            :class="`service-side-bar ${
              sidebarActive === item.id ? 'active-current-side-bar' : ''
            }`"
            @click="sidebarClick(item.id)"
          >
            {{ item.title }}
          </li>
        </ul>
        <div class="verticle-line">
          <span
            class="service-scroll-dot"
            id="service-scroll-dot"
            style="top: 0px"
          ></span>
        </div>
      </div>
      <div class="service-list-content">
        <div class="service-header collaspe" otdr="601">
          <div class="service-header__item">功能介绍</div>
          <div class="service-header__item">标准版</div>
          <div class="service-header__item">专业版</div>
          <div class="service-header__item">旗舰版</div>
        </div>
        <div
          v-for="(item, index) in sidebarArr"
          :key="`ssbc_${index}`"
          class="service-list-range-item"
          :id="item.id"
        >
          <div class="service-list-title">
            <span>{{ item.title }}</span>
          </div>
          <ul class="service-item">
            <li
              v-for="(sItem, sIndex) in item.produce"
              :key="`ssbcp_${sIndex}`"
            >
              <div class="service-item__name">
                <span class="service-item__title"> {{ sItem.title }}</span>
              </div>
              <div class="service-item__check">
                <div v-if="sItem.price" class="service-item__check_price">
                  <i class="T7 circle emptyCircle"></i>
                  <span class="T7 blue ml5">{{ sItem.price }}</span>
                </div>
                <div v-else class="service-item__check_price">
                  <i class="T7 circle solidCircle"></i>
                </div>
              </div>
              <div class="service-item__check">
                <div v-if="sItem.price2" class="service-item__check_price">
                  <i class="T7 circle emptyCircle"></i>
                  <span class="T7 blue ml5">{{ sItem.price2 }}</span>
                </div>
                <div v-else class="service-item__check_price">
                  <i class="T7 circle solidCircle"></i>
                </div>
              </div>
              <div class="service-item__check">
                <div v-if="sItem.price3" class="service-item__check_price">
                  <i class="T7 circle emptyCircle"></i>
                  <span class="T7 blue ml5">{{ sItem.price3 }}</span>
                </div>
                <div v-else class="service-item__check_price">
                  <i class="T7 circle solidCircle"></i>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <v-free title="现在加入，立享新商家专享优惠礼包" href="/"></v-free>
  </div>
</template>

<script>
import Free from '@/components/Free';
import SwiperCore, { Controller } from 'swiper';
SwiperCore.use([Controller]);
const sidebarArr = [
  {
    title: '知识商品',
    id: 'func-bar-course',
    produce: [
      { title: '图文课程' },
      { title: '音频课程' },
      { title: '视频课程' },
      { title: '直播课程' },
      { title: '专栏' },
      { title: '会员' },
      { title: '训练营', price: '¥988/年' },
      { title: '电子书', price: '¥988/年', price2: '¥988/年' },
      { title: '付费问答', price: '¥1988/年', price2: '¥1988/年' }
    ]
  }, {
    title: '实物商品',
    id: 'func-bar-entity',
    produce: [
      { title: '实物售卖' },
      { title: '课程带货', price: '¥1988/年' },
      { title: '直播带货' }
    ]
  }, {
    title: '直播营销',
    id: 'func-bar-alive-market',
    produce: [
      { title: '语音直播' },
      { title: '录播视频+语音直播', price: '¥1988/年' },
      { title: 'PPT直播' },
      { title: '图片放映+语音直播' },
      { title: '桌面共享直播' },
      { title: '应用窗口共享直播', price: '不限人次，免流量费，零延迟', price2: '不限人次，免流量费，零延迟', price3: '不限人次，免流量费，零延迟' },
      { title: '直播回看' },
      { title: '直播间打赏' },
      { title: '实时直播数据' },
      { title: '画板涂鸦' },
      { title: '直播回放清晰度' }
    ]
  }, {
    title: '班课',
    id: 'func-bar-interact',
    produce: [
      { title: '视频互动直播' },
      { title: '互动连麦' },
      { title: '随机选人' },
      { title: '在线抢答', price: '新客户赠送100元流量费用', price2: '新客户赠送1000元流量费用', price3: '新客户赠送10000元流量费用' },
      { title: '举手发言' },
      { title: '奖励勋章' }
    ]
  }, {
    title: '教培产品',
    id: 'func-bar-edu',
    produce: [
      { title: '面授课程' },
      { title: '报名表单' },
      { title: '线索管理' },
      { title: '教务管理' },
      { title: '学员管理' }
    ]
  }, {
    title: '企培产品',
    id: 'func-bar-company',
    produce: [
      { title: '组织管理' },
      { title: '内训模式' }
    ]
  }, {
    title: '助学工具',
    id: 'func-bar-help',
    produce: [
      { title: '小社群' },
      { title: '打卡' },
      { title: '考试', price: '¥388/年' },
      { title: '作业本', price: '¥388/年' },
      { title: '练习', price: '¥388/年' },
      { title: '题库', price: '¥388/年' },
      { title: '证书', price: '¥388/年' },
      { title: '随堂检测', price: '¥388/年' }
    ]
  }, {
    title: '营销玩法',
    id: 'func-bar-marketing',
    produce: [
      { title: '推广员' },
      { title: '买赠' },
      { title: '邀请码' },
      { title: '兑换码' },
      { title: '优惠券' },
      { title: '有价优惠券' },
      { title: '优惠码' },
      { title: '拼团' },
      { title: '划线价格' },
      { title: '请好友看' },
      { title: '限时折扣' },
      { title: '弹窗广告', price: '¥388/年' },
      { title: '支付有礼', price: '¥388/年' },
      { title: '裂变海报', price: '¥588/年' },
      { title: '涨粉神器', price: '¥388/年' },
      { title: '优秒杀', price: '¥388/年' },
      { title: '测试互动', price: '¥388/年' },
      { title: '商品推荐', price: '¥588/年' }
    ]
  }, {
    title: '用户管理',
    id: 'func-bar-user',
    produce: [
      { title: '表单', price: '¥388/年' },
      { title: '信息采集', price: '¥588/年' },
      { title: '群工具', price: '¥988/年' },
      { title: '超级会员', price: '¥988/年', price2: '¥988/年' },
      { title: '积分商城', price: '¥988/年', price2: '¥988/年' },
      { title: '活动管理', price: '¥1988/年', price2: '¥1988/年' }
    ]
  }, {
    title: '版权保护',
    id: 'func-bar-copyright',
    produce: [
      { title: '内容加密' },
      { title: '固定水印' },
      { title: '浏览器防录屏' },
      { title: '防录屏跑马灯' },
      { title: '积播放域名防盗链' },
      { title: '活课程查看限制' }
    ]
  }, {
    title: '课程分销',
    id: 'func-bar-class',
    produce: [
      { title: '店铺内容分销市场' }
    ]
  }, {
    title: '配套工具',
    id: 'func-bar-matching',
    produce: [
      { title: '视频清晰度', price: '高清720P', price2: '高清720P', price3: '超清1080P' },
      { title: '页面统计' },
      { title: '二维码/短链生成' },
      { title: '短信群发', price: '按需购买', price2: '按需购买', price3: '按需购买' }
    ]
  }, {
    title: '多终端支持',
    id: 'func-bar-multiTerminal',
    produce: [
      { title: '微信H5店铺' },
      { title: '微信小程序', price: '¥1888/年' },
      { title: 'PC端独立官网', price: '¥3988/年', price2: '¥3988/年' },
      { title: 'SDK服务', price: '¥49800/年', price2: '¥49800/年', price3: '¥49800/年' }
    ]
  }, {
    title: '知识店铺基础功能',
    id: 'func-bar-knowledgeShop',
    produce: [
      { title: '店铺管理' },
      { title: '订单管理' },
      { title: '商品管理' },
      { title: '数据分析' },
      { title: '资产管理' },
      { title: '品牌形象包' },
      { title: '信息隐藏', price: '¥3988/年', price2: '¥3988/年' },
      { title: '素材中心', price: '200GB存储空间', price2: '400GB存储空间', price3: '1000GB存储空间' },
      { title: '下载中心' },
      { title: '管理员帐号', price: '3个', price2: '30个', price3: '300个' }
    ]
  }, {
    title: '未来新增能力',
    id: 'func-bar-future',
    produce: [
      { title: '新增获客渠道', price: '待定价', price2: '待定价' },
      { title: '最新营销/管理/分析工具使用权益', price: '待定价', price2: '待定价' }
    ]
  }
];

export default {
  data() {
    return {
      isShowSidebar: false,
      sidebarTop: 266,
      sidebarArr,
      sidebarActive: '',
      swiperOptions: {
        slidesPerView: 'auto',
        centeredSlides: true,
        watchSlidesProgress: true,
        spaceBetween: 16
      },
      serverListFixedClass: '',
      sidebarActiveApp: {}
    };
  },
  components: {
    'v-free': Free
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll);
    let swiper1 = new SwiperCore('.list-swiper', {
      freeMode: true,
      freeModeMomentum: false,
      slidesPerView: 'auto',
      controller: {
        control: swiper2
      }
    });
    let swiper2 = new SwiperCore('.list-desc-content', {
      freeMode: true,
      freeModeMomentum: false,
      slidesPerView: 'auto',
      controller: {
        control: swiper1
      }
    });
  },
  methods: {
    handleScroll() {
      let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
      // console.log(scrollTop);
      if (this.$store.state.sceneClassName === 'app') {
        if (scrollTop > this.$el.querySelector('.server-list-wrapper').offsetTop) {
          this.serverListFixedClass = 'server-list-fixed';
        } else {
          this.serverListFixedClass = '';
        }
        sidebarArr.map((item, index) => {
          if (this.$el.querySelector('#' + item.id).offsetTop + 876 < scrollTop) {
            this.sidebarActiveApp = item;
          }
        });
      } else {
        sidebarArr.map((item, index) => {
          if (this.$el.querySelector('#' + item.id).offsetTop + 876 < scrollTop) {
            this.sidebarActive = item.id;
          }
        });
        this.isShowSidebar = (scrollTop > 1160 && scrollTop < 5900);
        this.sidebarTop = (scrollTop > 5600) ? 160 : 266;
      }
    },
    sidebarClick(id) {
      const t = document.getElementById(id).offsetTop;
      document.documentElement.scrollTop = t + 906;
      document.body.scrollTop = t;
      this.sidebarActive = id;
    }
  }
};
</script>

<style lang="scss">
.price-modular {
  .price-banner {
    padding-top: 70px;
    background-color: #f4f9ff;
  }
  .price-banner .banner-title {
    padding-top: 88px;
    padding-bottom: 16px;
    line-height: 56px;
    font-size: 40px;
    color: #353535;
    text-align: center;
  }
  .price-banner .banner-sub-title {
    margin-bottom: 32px;
    text-align: center;
    line-height: 25px;
    font-size: 26px;
    color: #999;
  }
  .price-banner .BigBtnType1 {
    padding: 0 32px;
    width: 120px;
    height: 36px;
    line-height: 36px;
    border-radius: 22px;
    font-size: 14px;
  }
  .type-header .tip_module {
    position: absolute;
    right: 120px;
    top: 8px;
  }
  .type-header .tip {
    position: relative;
  }
  .type-header .tip:hover .tip-text {
    display: block;
  }
  .type-header .tip-icon {
    width: 16px;
    height: 16px;
    cursor: pointer;
  }
  .type-header .tip-text {
    position: absolute;
    z-index: 9;
    top: 10px;
    left: 8px;
    width: 316px;
    height: 128px;
    display: none;
  }
  .type-header .tip-text img {
    vertical-align: middle;
    width: 100%;
    height: 100%;
  }
  .type-wrap {
    margin: 0 auto;
    padding: 80px 0 64px;
    background-color: #f4f9ff;
  }
  .type-wrap .type {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
  }
  .type-wrap .type-item {
    width: 368px;
    height: 676px;
    background: #fff;
    position: relative;
    text-align: center;
    border-radius: 8px;
    border: 1px solid #e5e5e5;
    -webkit-transition: all 1s;
    transition: all 1s;
  }
  .type-wrap .type-item .recommend_img {
    width: 58px;
    position: absolute;
    right: 0;
    top: -10px;
  }
  .type-wrap .type-item .type-header {
    margin-left: -1px;
    margin-top: -1px;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
    width: 368px;
    height: 120px;
    border-radius: 8px 8px 0 0;
    font-weight: 500;
    color: #586166;
    font-size: 30px;
  }
  .type-wrap .type-item .type-header-one {
    background: linear-gradient(135deg, #ebf3ff 0, #c2cdd7 100%);
  }
  .type-wrap .type-item .type-header-two {
    color: #fff;
    background: linear-gradient(135deg, #4791ff 0, #1472ff 100%);
  }
  .type-wrap .type-item .type-header-three {
    color: #7e551f;
    background: linear-gradient(135deg, #f4e1b3 0, #ddb377 100%);
  }
  .type-wrap .type-item .type-header-desc {
    margin-top: 4px;
    font-size: 14px;
    font-weight: 400;
    opacity: 0.8;
  }
  .type-wrap .type-item .version-person {
    padding-top: 24px;
    padding-bottom: 32px;
    font-size: 16px;
    color: #333;
    line-height: 20px;
  }
  .type-wrap .type-item .version-desc {
    padding: 0 48px;
    height: 305px;
    color: #666;
    line-height: 22px;
    text-align: justify;
    font-size: 14px;
  }
  .type-wrap .type-item .version-desc .version-content {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: baseline;
    -ms-flex-align: baseline;
    align-items: baseline;
    margin-top: 16px;
    line-height: 22px;
  }
  .type-wrap .type-item .version-desc .version-content:first-child {
    margin-top: 0;
  }
  .type-wrap .type-item .version-desc .version-content .version-point {
    margin-right: 19px;
    -ms-flex-negative: 0;
    flex-shrink: 0;
    width: 10px;
    height: 10px;
    background-color: #1472ff;
    border-radius: 50%;
  }
  .type-wrap .type-item .price-box {
    position: relative;
    height: 56px;
    margin-bottom: 20px;
  }
  .type-wrap .type-item .old-price {
    position: absolute;
    top: -15px;
    left: 35%;
    color: #999;
  }
  .type-wrap .type-item .type-price {
    height: 56px;
    line-height: 56px;
    color: #353535;
    font-weight: 500;
  }
  .type-wrap .type-item .type-price span {
    font-size: 20px;
  }
  .type-wrap .type-item .type-price .type-price-num {
    font-size: 40px;
  }
  .type-wrap .type-item .type-price .priceIcon {
    font-size: 38px;
    margin-right: -10px;
  }
  .type-wrap .type-item .type-price .c-3DA4FF {
    color: #7c8faf;
  }
  .type-wrap .type-item .type-price .c-2D74F1 {
    color: #333;
  }
  .type-wrap .type-item .type-price .c-B98666 {
    color: #7e551f;
  }
  .type-wrap .type-item .type-compare {
    height: 20px;
    line-height: 20px;
    font-size: 0;
  }
  .type-wrap .type-item .type-btn {
    display: block;
    width: 240px;
    height: 40px;
    line-height: 40px;
    border-radius: 24px;
    font-size: 16px;
    color: #333;
    text-align: center;
    margin: 0 auto;
  }
  .type-wrap .type-item .type-btn-one,
  .type-wrap .type-item .type-btn-three {
    border-radius: 24px;
    border: 1px solid #333;
  }
  .type-wrap .type-item .type-btn-two {
    color: #fff;
    background: -webkit-gradient(
      linear,
      left top,
      right top,
      color-stop(0, #79a2fa),
      to(#105cfb)
    );
    background: linear-gradient(90deg, #79a2fa 0, #105cfb 100%);
  }
  .type-wrap .type-item:hover {
    -webkit-box-shadow: 0 20px 40px 0 rgba(16, 92, 251, 0.16);
    box-shadow: 0 20px 40px 0 rgba(16, 92, 251, 0.16);
    border: 1px solid transparent;
  }
  .type-wrap .type-item:hover .type-btn {
    border-color: transparent;
  }
  .type-wrap .type-item:hover .type-btn-one {
    color: #586166;
    background: linear-gradient(135deg, #ebf3ff 0, #c2cdd7 100%);
    font-weight: 500;
  }
  .type-wrap .type-item:hover .type-btn-two {
    opacity: 0.9;
  }
  .type-wrap .type-item:hover .type-btn-three {
    color: #7e551f;
    background: linear-gradient(135deg, #f4e1b3 0, #ddb377 100%);
    font-weight: 500;
  }
  .func {
    width: 1200px;
    margin: 0 auto;
  }
  .func .func-list {
    position: relative;
    border: 1px solid #e7e7e7;
    -webkit-box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.05);
    box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.05);
    border-radius: 6px;
    padding: 0 30px;
    margin-bottom: 10px;
  }
  .func .func-list.hidden-list {
    height: 70px;
    overflow: hidden;
  }
  .func .func-list.hidden-list .narraw {
    -webkit-transform: rotate(-45deg);
    transform: rotate(-45deg);
  }
  .func .func-list .func-list-id {
    position: absolute;
    top: -290px;
  }
  .func .func-list .func-list-title {
    position: relative;
    height: 70px;
    line-height: 70px;
    color: #333;
    font-size: 18px;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    cursor: pointer;
  }
  .func .func-list .func-list-title .icon-gongnengdingyi {
    font-size: 24px;
    margin-right: 10px;
  }
  .func .func-list .func-list-title .func-list-title-edu,
  .func .func-list .func-list-title .func-list-title-normal {
    width: 100px;
    height: 70px;
    line-height: 70px;
    text-align: center;
    color: #fb6161;
    font-size: 16px;
  }
  .func .func-list .func-list-title .func-list-title-edu {
    position: absolute;
    right: 297px;
    top: 0;
  }
  .func .func-list .func-list-title .func-list-title-normal {
    position: absolute;
    right: 520px;
    top: 0;
  }
  .func .func-list .func-list-item {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    line-height: 48px;
    font-size: 14px;
    color: #333;
    margin: 0 30px;
  }
  .func .func-list .func-list-item:last-child {
    margin-bottom: 20px;
  }
  .func .func-list .func-list-item .func-item-name {
    width: 275px;
  }
  .func .func-list .func-list-item .func-item-tips {
    width: 178px;
  }
  .func .func-list .func-list-item .func-item-edu,
  .func .func-list .func-list-item .func-item-more,
  .func .func-list .func-list-item .func-item-normal {
    width: 200px;
    text-align: center;
    line-height: 48px;
    color: #2a75ed;
    font-size: 15px;
  }
  .func .func-list .func-list-item .func-item-edu {
    margin: 0 17px;
  }
  .func .check-all,
  .func .close-more-list {
    border-radius: 4px;
    font-size: 16px;
    line-height: 48px;
    margin: 20px auto 80px;
    text-align: center;
    cursor: pointer;
  }
  .func .func-list .func-list-item .color-red {
    color: #fb6161;
  }
  .func .func-list .func-list-item .color-black {
    color: #666;
  }
  .func .func-list .func-list-item .color-gray {
    color: #888;
  }
  .func .more-func-list {
    display: none;
  }
  .func .close-more-list {
    width: 240px;
    height: 48px;
    border: 1px solid #1472ff;
    color: #1472ff;
  }
  .func .close-more-list:hover {
    background: #1472ff;
    color: #fff;
    -webkit-transition: all 0.3s;
    transition: all 0.3s;
  }
  .func .show-shade {
    position: absolute;
    left: 0;
    top: 0;
    width: 1200px;
    height: 100%;
    background: -webkit-gradient(
      linear,
      left top,
      left bottom,
      color-stop(0, rgba(255, 255, 255, 0)),
      to(#fff)
    );
    background: linear-gradient(180deg, rgba(255, 255, 255, 0) 0, #fff 100%);
  }
  .func .check-all {
    width: 240px;
    height: 48px;
    border: 1px solid #1472ff;
    color: #1472ff;
  }
  .func .check-all:hover {
    background: #1472ff;
    color: #fff;
    -webkit-transition: all 0.3s;
    transition: all 0.3s;
  }
  .new-user-pay {
    width: 100%;
    height: 300px;
    background-color: #1472ff;
  }
  .new-user-pay .pay-title {
    font-size: 32px;
    line-height: 46px;
    color: #fff;
    padding-top: 80px;
    padding-bottom: 38px;
    text-align: center;
  }
  .new-user-pay .pay-free-btn {
    margin: 0 auto;
    width: 160px;
    height: 48px;
    background: #fff;
    border-radius: 4px;
    text-align: center;
    line-height: 48px;
    cursor: pointer;
  }
  .new-user-pay .pay-free-btn a {
    color: #1472ff;
    font-size: 16px;
  }
  .contact {
    text-align: center;
    color: #333;
  }
  .contact .contact-title {
    line-height: 50px;
    font-size: 30px;
    margin: 0 0 20px;
  }
  .contact .tel-phone-txt {
    display: inline-block;
    font-size: 22px;
    font-weight: 700;
  }
  .contact .contact-tips {
    line-height: 20px;
  }
  .contact .trigger-btn {
    display: block;
    width: 180px;
    height: 52px;
    line-height: 52px;
    background: #1472ff;
    color: #fff;
    font-size: 16px;
    margin: 50px auto 77px;
    -webkit-box-shadow: 0 5px 15px 0 rgba(16, 92, 251, 0.2);
    box-shadow: 0 5px 15px 0 rgba(16, 92, 251, 0.2);
  }
  .func .func-list .func-list-item .service-black-flag {
    font-size: 14px;
  }
  .merge-number-left,
  .merge-number-right {
    position: absolute;
    top: 15.5rem;
    color: #fb616e;
    font-size: 15px;
  }
  .merge-number-left {
    left: 35.5rem;
  }
  .merge-number-right {
    left: 49.5rem;
  }
  .service-list {
    border-bottom: 1px solid #e5e5e5;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    position: relative;
    margin-bottom: 96px;
  }
  .service-list .service-side-bar-list {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    width: 130px;
    position: fixed;
    left: 10px;
    top: 266px;
    font-size: 14px;
    z-index: 1;
  }
  .service-list .service-side-bar-list li {
    margin: 10px 8px 10px 0;
    text-align: right;
    font-weight: 400;
    color: #999;
    cursor: pointer;
  }
  .service-list .service-side-bar-list .active-current-side-bar {
    color: #1472ff;
    font-weight: 500;
  }
  .service-list .verticle-line {
    position: relative;
    top: 16px;
    width: 2px;
    height: 408px;
    background: #e5e5e5;
  }
  .service-list .service-scroll-dot {
    position: absolute;
    top: 0;
    left: -50%;
    margin-left: -3px;
    display: inline-block;
    width: 10px;
    height: 10px;
    background: #1472ff;
    border-radius: 50%;
  }
  .service-list .service-list-content {
    margin-top: 64px;
    width: 100%;
  }
  .service-list .service-header {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    width: 100%;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    font-size: 18px;
    color: #353535;
    height: 48px;
    line-height: 48px;
    background: #fff;
  }
  .service-list .service-header .service-header__item {
    -webkit-box-flex: 1;
    -ms-flex: 1;
    flex: 1;
    text-align: center;
    font-weight: 500;
  }
  .service-list .service-header .service-header__item:first-child {
    color: #999;
    font-size: 16px;
    text-align: left;
    padding-left: 16px;
  }
  .service-list .service-list-title {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    height: 64px;
    line-height: 64px;
    font-size: 18px;
    color: #333;
    padding-left: 16px;
    font-weight: 600;
    background-color: #f6faff;
  }
  .service-list .service-item__name .tip,
  .service-list .service-list-title .tip {
    margin-left: 8px;
    position: relative;
    top: 2px;
  }
  .service-list .service-item__name .tip:hover .tip-text,
  .service-list .service-list-title .tip:hover .tip-text {
    display: block;
  }
  .service-list .service-item__name .tip-icon,
  .service-list .service-list-title .tip-icon {
    width: 14px;
    height: 14px;
    cursor: pointer;
  }
  .service-list .service-item__name .tip-text,
  .service-list .service-list-title .tip-text {
    text-align: center;
    width: aoto;
    white-space: nowrap;
    position: absolute;
    top: -30px;
    left: 20px;
    display: none;
    font-size: 14px;
    color: #333;
  }
  .service-list .service-item__name .tip-text img,
  .service-list .service-list-title .tip-text img {
    vertical-align: middle;
  }
  .service-list .service-item__name .tip-text .w_865,
  .service-list .service-list-title .tip-text .w_865 {
    width: 865px;
  }
  .service-list .service-item li {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    width: 100%;
    height: 48px;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    border-top: 1px solid #eee;
  }
  .service-list .service-item li .service-item__name {
    font-size: 14px;
    width: 25%;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
  }
  .service-list .service-item li .service-item__name .service-item__title {
    color: #333;
    padding-left: 16px;
  }
  .service-list .service-item li .service-item__check {
    -webkit-box-flex: 1;
    -ms-flex: 1;
    flex: 1;
    text-align: center;
  }
  .service-list .service-item li .service-item__check .red {
    color: #fb6161;
  }
  .service-list
    .service-item
    li
    .service-item__check
    .service-item__check_price {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
  }
  .service-list .service-item li:hover {
    background-color: #fafcff;
  }
  .service-list .service-item li:first-child {
    border: none;
  }
  .service-list .service-item .service-item-merge {
    height: auto;
  }
  .service-list .service-item .service-item-merge .service-item__name {
    display: block;
  }
  .service-list
    .service-item
    .service-item-merge
    .service-item-merge-name__block {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    height: 50px;
    line-height: 50px;
  }
  .service-list
    .service-item
    .service-item-merge
    .service-item-merge-name__block
    .tip:hover
    .tip-text {
    display: block;
  }
  .service-list
    .service-item
    .service-item-merge
    .service-item-merge-name__block
    .tip-text {
    padding: 10px;
    opacity: 1;
    display: none;
  }
  .service-list
    .service-item
    .service-item-merge
    .service-item-merge-name__block
    .tip-text
    img {
    vertical-align: middle;
  }
  .service-list
    .service-item
    .service-item-merge
    .service-item-merge-name__block
    .tip-text
    .w_661 {
    width: 661px;
  }
  .service-list
    .service-item
    .service-item-merge
    .service-item-merge-name__block
    .tip-text
    .w_459 {
    width: 459px;
  }
  .service-list .guide-fixed__item .ml5,
  .service-list .service-item__check .ml5 {
    margin-left: 5px;
  }
  .service-list .guide-fixed__item .blue,
  .service-list .service-item__check .blue {
    color: #1472ff;
  }
  .service-list .guide-fixed__item .circle,
  .service-list .service-item__check .circle {
    display: inline-block;
    width: 10px;
    height: 10px;
    border-radius: 50%;
    vertical-align: middle;
  }
  .service-list .guide-fixed__item .emptyCircle,
  .service-list .service-item__check .emptyCircle {
    border: 2px solid #1472ff;
    margin-bottom: -2px;
  }
  .service-list .guide-fixed__item .solidCircle,
  .service-list .service-item__check .solidCircle {
    background: #1472ff;
  }
  .service-list .guide-fixed__item .solidLine,
  .service-list .service-item__check .solidLine {
    display: inline-block;
    width: 12px;
    height: 2px;
    background: #cad3e3;
    vertical-align: middle;
  }
  .service-list .guide-fixed__item .grey,
  .service-list .service-item__check .grey {
    color: #999;
  }
  .service-list .guide {
    display: none;
  }
  .service-list .guide.guide-fixed__active {
    display: block;
  }
  .service-list .guide-fixed {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    height: 154px;
    background: rgba(240, 249, 255, 0.4);
    -webkit-backdrop-filter: saturate(180%) blur(6px);
    backdrop-filter: saturate(180%) blur(6px);
    position: fixed;
    top: 70px;
    border: 1px solid transparent;
    z-index: 2;
  }
  .service-list .guide-fixed .guide-fixed__item {
    -webkit-box-flex: 1;
    -ms-flex: 1;
    flex: 1;
    text-align: center;
    height: 100%;
  }
  .service-list .guide-fixed .guide-fixed__item .fun-list-intro {
    text-align: left;
    padding-left: 16px;
    margin-bottom: 6px;
  }
  .service-list .guide-fixed .guide-fixed__item .fun-list-intro span {
    margin-left: 6px;
  }
  .service-list .guide-fixed .guide-fixed__item .version-title {
    font-size: 24px;
    color: #333;
    height: 34px;
    line-height: 34px;
    margin-bottom: 24px;
    margin-top: 24px;
  }
  .service-list .guide-fixed .guide-fixed__item .type-btn {
    display: block;
    width: 160px;
    height: 44px;
    line-height: 44px;
    border-radius: 24px;
    font-size: 16px;
    color: #fff;
    text-align: center;
    margin: 0 auto;
  }
  .service-list .guide-fixed .guide-fixed__item .type-btn:hover {
    opacity: 0.9;
  }
  .service-list .guide-fixed .guide-fixed__item .type-btn-one {
    color: #586166;
    background: linear-gradient(135deg, #ebf3ff 0, #c2cdd7 100%);
  }
  .service-list .guide-fixed .guide-fixed__item .type-btn-two {
    background: -webkit-gradient(
      linear,
      left top,
      right top,
      color-stop(0, #79a2fa),
      to(#105cfb)
    );
    background: linear-gradient(90deg, #79a2fa 0, #105cfb 100%);
  }
  .service-list .guide-fixed .guide-fixed__item .type-btn-three {
    color: #7e551f;
    background: linear-gradient(135deg, #f4e1b3 0, #ddb377 100%);
  }
  .service-list .guide-fixed .list-wrap {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
  }
  @media screen and (max-width: 1440px) {
    #service-side-bar-list {
      display: none;
      opacity: 0;
    }
  }
}
.app .price-modular {
  overflow: hidden;
  .free-price-btn {
    display: block;
    width: 3.2rem;
    height: 0.8rem;
    line-height: 0.8rem;
    background: #1472ff;
    border-radius: 0.88rem;
    text-align: center;
    margin: 0 auto;
    color: #fff;
    font-size: 0.32rem;
  }
  .price-banner {
    padding-top: 1.88rem;
    background-color: #ffffff;
    .banner-title {
      padding: 0;
      line-height: 1.12rem;
      font-size: 0.8rem;
    }
    .banner-sub-title {
      margin: 0.24rem 0 0.48rem;
      font-size: 0.32rem;
      line-height: 0.48rem;
    }
  }
  .type-wrap {
    background-color: #ffffff;
    padding-top: 1.64rem;
    padding-bottom: 0;
    .swiper-slide {
      position: relative;
      width: 6.22rem;
      height: 13.72rem;
      background-color: #fff;
      border-radius: 0.16rem;
      border: 0.02rem solid #e5e5e5;
    }
    .swiper-slide-active {
      box-shadow: 0 20px 40px 0 rgba(16, 92, 251, 0.16);
    }
    .swiper-container {
      overflow: visible;
    }
    .version-top {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      width: 100%;
      height: 2.4rem;
      background: linear-gradient(135deg, #ebf3ff 0, #c2cdd7 100%);
      border-radius: 0.08rem 0.08rem 0 0;
      font-size: 0.6rem;
      color: #586166;
    }
    .version-desc-area {
      position: relative;
      padding: 0.48rem 0.32rem 0.8rem;
      font-size: 0.32rem;
      text-align: center;
      .version-desc-person {
        line-height: 0.4rem;
        color: #333;
      }
      .version-content {
        margin-top: 0.6rem;
        color: #666;
        height: 6.5rem;
        line-height: 0.48rem;
        font-size: 0.28rem;
        .version-desc-content {
          display: flex;
          align-items: baseline;
          margin-top: 0.32rem;
          line-height: 0.44rem;
          text-align: justify;
          &:first-child {
            margin-top: 0;
          }
          .version-desc-point {
            margin-left: 0.08rem;
            margin-right: 0.38rem;
            -ms-flex-negative: 0;
            flex-shrink: 0;
            width: 0.2rem;
            height: 0.2rem;
            background-color: #1472ff;
            border-radius: 50%;
          }
        }
      }
      .version-price {
        margin-bottom: 0.32rem;
        width: 5.58rem;
        text-align: center;
        .price {
          font-size: 0.8rem;
          color: #7c8faf;
          span {
            font-size: 0.4rem;
          }
        }
      }
      .version-buy-btn {
        display: inline-block;
        width: 4.8rem;
        height: 0.88rem;
        line-height: 0.88rem;
        border-radius: 0.48rem;
        text-align: center;
        font-size: 0.32rem;
        color: #333;
        background: linear-gradient(135deg, #ebf3ff 0, #c2cdd7 100%);
      }
    }
  }
  .server-list-wrapper {
    margin: 1.6rem 0;
  }
  .server-list-wrapper .server-list-fixed {
    position: fixed;
    top: 1.04rem;
    left: 0;
    z-index: 2;
  }
  .server-list-wrapper .server-list-title {
    z-index: 3;
    background-color: #fff;
  }
  .server-list-wrapper .left {
    position: relative;
    z-index: 2;
    display: table-cell;
    width: 1.9rem;
    text-align: center;
    background-color: #f6faff;
  }
  .server-list-wrapper .list-desc-content,
  .server-list-wrapper .list-swiper {
    position: relative;
    display: table-cell;
    vertical-align: top;
  }
  .server-list-wrapper .compare {
    display: table;
    table-layout: fixed;
    width: 100%;
    height: 1.1rem;
    line-height: 1.1rem;
    border-top: 0.02rem solid #eee;
    border-bottom: 0.02rem solid #eee;
  }
  .server-list-wrapper .compare .function {
    position: relative;
    z-index: 3;
    background: rgba(240, 249, 255, 0.4);
    -webkit-backdrop-filter: saturate(180%) blur(6px);
    backdrop-filter: saturate(180%) blur(6px);
    color: #999;
    font-size: 0.24rem;
  }
  .server-list-wrapper .compare .list-swiper .swiper-slide {
    width: 2.56rem;
    background: linear-gradient(135deg, #ebf3ff 0, #c2cdd7 100%);
    color: #586166;
    font-size: 0.32rem;
    text-align: center;
  }
  .server-list-wrapper .compare .list-swiper .swiper-slide:nth-child(2) {
    background: linear-gradient(135deg, #4791ff 0, #1472ff 100%);
    color: #fff;
  }
  .server-list-wrapper .compare .list-swiper .swiper-slide:nth-child(3) {
    background: linear-gradient(135deg, #f4e1b3 0, #ddb377 100%);
    color: #7e551f;
  }
  .server-list-wrapper .category {
    position: relative;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
    padding: 0 0.32rem;
    width: 100vw;
    height: 0.8rem;
    background-color: #fff;
    overflow: hidden;
    border-bottom: 0.02rem solid #eee;
  }
  .server-list-wrapper .category .canBuy::before,
  .server-list-wrapper .category .inclued::before,
  .server-list-wrapper .category .noBuy::before {
    margin-right: 0.08rem;
    display: inline-block;
    content: '';
  }
  .server-list-wrapper .category .caption {
    font-size: 0.28rem;
    color: #333;
    font-family: PingFangSC-Medium, PingFang SC;
  }
  .server-list-wrapper .category .direction {
    font-size: 0.2rem;
    color: #333;
  }
  .server-list-wrapper .category .direction span {
    margin-left: 0.16rem;
  }
  .server-list-wrapper .category .inclued::before {
    width: 0.16rem;
    height: 0.16rem;
    border-radius: 50%;
    background-color: #1472ff;
  }
  .server-list-wrapper .category .canBuy::before {
    width: 0.1rem;
    height: 0.1rem;
    border-radius: 50%;
    border: 2px solid #1472ff;
  }
  .server-list-wrapper .category .noBuy::before {
    position: relative;
    top: -0.04rem;
    width: 0.16rem;
    height: 0.04rem;
    background-color: #cad3e3;
  }
  .server-list-wrapper .group .item {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    text-align: left;
    height: 0.96rem;
    padding: 0 0.24rem;
    border-bottom: 0.02rem solid #eee;
    border-right: 0.02rem solid #eee;
  }
  .server-list-wrapper .group:last-child .item:last-child,
  .server-list-wrapper
    .list-desc-content
    .list-group:last-child
    .list-item:last-child
    .inner {
    height: 1.76rem;
  }
  .server-list-wrapper .server-list-detail {
    display: table;
    table-layout: fixed;
    width: 100%;
  }
  .server-list-wrapper .server-list__top {
    margin-top: 3.6rem;
  }
  .server-list-wrapper .group:first-child .category {
    display: none;
  }
  .server-list-wrapper .list-desc-content .list-group {
    margin-top: 0.8rem;
  }
  .server-list-wrapper .list-desc-content .list-group:first-child {
    margin-top: 0;
  }
  .server-list-wrapper .list-desc-content .swiper-slide {
    width: 2.56rem;
  }
  .server-list-wrapper .list-desc-content .list-item {
    width: 2.56rem;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    border-bottom: 0.02rem solid #eee;
  }
  .server-list-wrapper .list-desc-content .list-item .inner {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    width: 2.56rem;
    height: 0.94rem;
    border-right: 0.02rem solid #eee;
  }
  .server-list-wrapper .list-desc-content .list-item .style-line {
    display: inline-block;
    width: 0.16rem;
    height: 0.04rem;
    background-color: #cad3e3;
  }
  .server-list-wrapper .list-desc-content .list-item .style-circle {
    display: inline-block;
    width: 0.16rem;
    height: 0.16rem;
    background-color: #1472ff;
    border-radius: 50%;
  }
  .server-list-wrapper .list-desc-content .list-item .style-radius {
    display: inline-block;
    width: 0.16rem;
    height: 0.16rem;
    border: 0.04rem solid #1472ff;
    border-radius: 50%;
  }
  .server-list-wrapper .list-desc-content .list-item .inner-price {
    margin-left: 0.08rem;
    color: #1472ff;
    font-size: 0.24rem;
  }
  .server-list-wrapper .list-desc-content .list-item .inner-text {
    margin-top: 0.2rem;
    height: 0.72rem;
    line-height: 0.36rem;
    color: #999;
    font-size: 0.2rem;
  }
  .server-list-wrapper .list-desc-content .list-item .inner-desc {
    color: #1472ff;
    font-size: 0.24rem;
  }
  .server-list-wrapper .list-desc-content .group-item {
    width: 7.68rem;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    height: 100%;
  }
  .server-list-wrapper .list-desc-content .group-item .inner {
    height: 100%;
  }
  .server-list-wrapper .list-desc-content .inner-column {
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
  }
}
</style>
